<template>
  <div
    class="search-field-date-input-with-label"
    :layout="`layout-${layout}`"
  >
    <label
      class="label"
      :for="id"
    >{{ labelValue }}</label>

    <span
      class="form-input search-keyword-field"
    >
      <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string
  id: string
  layout?: 'reverse' | 'default'
}

const props = withDefaults(defineProps<Props>(), {
  layout: 'default',
})

const labelValue = computed(() => props.label)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-field-date-input-with-label {
  display: flex;
  align-items: center;
  width: fit-content;

  &.layout-default {
    flex-direction: row;
  }

  &.layout-reverse {
    flex-direction: row-reverse;
  }

  .label {
    font-size: $size-7;
    padding: 0 0.25rem;
  }

  .form-input {
    width: fit-content;
    min-width: 2.5rem;
  }
}
</style>
